import { MediaImage } from '@elfsight/widget-media';
import { useSettings } from '@wu/widget-core';
import type { Job } from '../../../types';
import { coverUrl } from '../../utils';
import {
  Buttons,
  Description,
  getTitleBlockSettings,
  Skills,
  TitleBlock
} from './parts';

interface VerticalItemProps {
  data: Job;
  cardWidth?: number;
}

export function VerticalItem({ data, cardWidth }: VerticalItemProps) {
  const settings = useSettings();
  const {
    jobs,
    isShowApplyButton,
    isShowLearnMoreButton,
    jobDescriptionStyle,
    jobSkillsStyle,
    jobTextColor,
    jobLinkColor,
    isShowSkills,
    isShowDescription,
    isShowJobCover
  } = settings;

  const { title, description, skills, cover } = data;

  const img = coverUrl(cover, jobs);
  const withCover = isShowJobCover && !!img;

  return (
    <>
      {withCover && <MediaImage src={img} alt={title} ratio={0.6667} />}

      <TitleBlock
        {...data}
        {...getTitleBlockSettings(settings)}
        salaryAlign="flex-start"
        color={jobTextColor}
        withCover={withCover}
        cardWidth={Number(cardWidth)}
      />

      {isShowDescription && description && (
        <Description
          color={jobTextColor}
          linkColor={jobLinkColor}
          fontSize={jobDescriptionStyle.fontSize}
        >
          {description}
        </Description>
      )}

      {isShowSkills && skills?.length > 0 && (
        <Skills
          color={jobTextColor}
          items={skills}
          fontSize={jobSkillsStyle.fontSize}
        />
      )}

      {(isShowApplyButton || isShowLearnMoreButton) && (
        <Buttons
          direction={
            !withCover && Number(cardWidth) >= 560 ? 'row-reverse' : 'row'
          }
          data={data}
          isShowApplyButton={isShowApplyButton}
          isShowLearnMoreButton={isShowLearnMoreButton}
          isVertical
          cardWidth={cardWidth}
        />
      )}
    </>
  );
}
